import queryString from 'query-string'
import { useLocation } from "react-router-dom";
import { Card } from "react-bootstrap";
import { useEffect, useState } from "react";
import Api from "../../Api/Api";
import NavBar from '../Navbar';
import { username } from "../../API"
import React from 'react';
const PaymentDetails = () => {
    const [paymentDetails, setPaymentDetails] = useState(null);
    let { search } = useLocation();
    let { session_id } = queryString.parse(search);
    useEffect(() => {
        const getData = async () => {
            const { data } = await Api.geyPaymentDetails({ username, session_id })
            setPaymentDetails(data);
            localStorage.setItem("payment", true)
        }
        getData();
    }, [session_id])
    return (
        <div className="d-inline-flex flex-wrap w-100 justify-content-center align-items-center" style={{ height: "100vh" }}>
            <NavBar />
            <Card style={{ height: "30em", width: "35em" }}>
                {paymentDetails &&
                    <div className="d-flex flex-wrap flex-column w-100">
                        <h3 className="text-success text-center mt-5 mb-5">Payment Successfull!</h3>
                        <div className="d-flex flex-wrap justify-content-between">
                            <div className="text-muted ms-5">Payment Type</div>
                            <div className="text-dark me-5 mb-3">{paymentDetails.session.payment_method_types}</div>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between">
                            <div className="text-muted ms-5 mb-3">Mobile</div>
                            <div className="text-dark me-5">{paymentDetails.session.customer_details?.mobileNumber ? paymentDetails.session.customer_details?.mobileNumber : "N/A"}</div>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between">
                            <div className="text-muted ms-5 mb-3">Email</div>
                            <div className="text-dark me-5">{paymentDetails.session.customer_details?.email}</div>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between mt-3">
                            <h4 className="text-dark ms-5 mb-3">Amount Paid</h4>
                            <div className="text-dark me-5">{paymentDetails.session.amount_subtotal}</div>
                        </div><div className="d-flex flex-wrap justify-content-between">
                            <div className="text-muted ms-5 mb-3">Payment Intent</div>
                            <div className="text-muted me-5">{paymentDetails.session.payment_intent}</div>
                        </div>
                    </div>
                }
            </Card>
        </div>
    )
}
export default PaymentDetails;

//cs_test_a1AWR6qDpC89VOBcS59vHrhNWvy77Hz9NcOiECDTygVnXFDLfQpOoIPQTm